import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
export class EvaluationJure {
    static jsonMap = {
        id: { key: 'id' },
        idJure: { key: 'idJure' },
        idCritereEvaluation: { key: 'idCritereEvaluation' },
        idLeurre: { key: 'idLeurre' },
        valeurOui: { key: 'valeurOui' },
        dateCommission: { key: 'dateCommission', converter: new DateConverter(), optional: true },
        typeLeurre: { key: 'typeLeurre', optional: true, default: '' }
    };

    id: number;
    idJure: number;
    idCritereEvaluation: number;
    idLeurre: number;
    valeurOui: boolean;
    dateCommission: moment.Moment;
    typeLeurre: string;
}
